
import moment from 'moment';
/**
 * @classdesc Un pack de course d'un module
 * @kind class
 * @export
 * @prop {int} id - Id du pack
 * @prop {string} nom - Nom du pack
 * @prop {int} id_module - Id du module
 * @prop {int} tarif - Prix du pack
 * @prop {array} list_liaisons - Courses du pack
 * @prop {array} metadatas - Métadonnées du pack
 * @class Pack_Courses
 */
export default class Pack_Courses {
    id = "";
    nom = "";
    id_module = "";
    tarif = "";
    list_liaisons = [];
    metadatas = [];
    selected = false;

    /**
     * Creates an instance of Pack_Courses.
     * @constructs
     * @kind function
     * @memberof Pack_Courses
     */
    constructor() { }



    /**
     * Défini un pack de course à partir d'un jeu de données
     *
     * @param {Object} data
     * @memberof Pack_Courses
     */
    set(data) {
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                this[key] = value;
            }
        }
        for (let i = 0; i < this.list_liaisons.length; i++) {
            this.list_liaisons[i].selected = true;
        }

    }

    update_from_course_selection(courses) {
        let is_selected = true;
        let count_selected = 0;
        for (let i = 0; i < courses.length; i++) {
            if (this.course_in_pack(courses[i].id)) {
                count_selected++;
                is_selected = is_selected && courses[i].selected;
            }
        }
        if (count_selected < this.list_liaisons.length) {
            is_selected = false;
        }
        this.selected = is_selected;
    }

    course_in_pack(id) {
        for (let i = 0; i < this.list_liaisons.length; i++) {
            if (this.list_liaisons[i].id_course == id) {
                return true;
            }
        }
        return false;
    }

    update_cart(lien_groupe = null) {
        let cart = { nb_articles: 0, prix: 0, prix_regulier: 0 };
        if (this.selected) {
            cart.nb_articles = 1;
            let prix_normal = parseFloat(this.get_default_price());
            cart.prix = prix_normal;
            cart.prix_regulier = prix_normal;
            if (lien_groupe && !lien_groupe.doit_payer) {
                cart.prix = 0;
            }
        }
        this.current_price = cart.prix;
        this.cart = cart;
        return cart;
    }





    get_default_price() {
        let prix = parseFloat(this.tarif);
        let possible_majoration_price = this.get_majoration_price();
        prix = Math.max(prix, parseFloat(possible_majoration_price));
        return prix;
    }

    get_majoration_price() {
        let price = 0;
        let majorations = this.get_majorations();
        for (let i = 0; i < majorations.length; i++) {
            let now = moment();
            let date_majoration = moment(majorations[i].date);
            if (now.isAfter(date_majoration) && parseFloat(majorations[i].tarif) > parseFloat(price)) {
                price = majorations[i].tarif;
            }
        }
        return parseInt(price);
    }

    get_majorations() {
        let list_majorations = [];
        let majorations_metadatas = this.metadatas.filter(metadata => metadata.nom.startsWith("majoration_"));
        for (let i = 1; i < 10; i++) {
            let majoration_date_name = "majoration_" + i + "_date";
            let majoration_tarif_name = "majoration_" + i + "_tarif";
            let date = majorations_metadatas.find(majoration => majoration.nom == majoration_date_name);
            let tarif = majorations_metadatas.find(majoration => majoration.nom == majoration_tarif_name);
            if (!date || !tarif) break;
            list_majorations.push({ "date": date.valeur, "tarif": tarif.valeur });
        }
        return list_majorations;
    }

    has_upcoming_majoration() {
        let majorations = this.get_majorations();
        for (let i = 0; i < majorations.length; i++) {
            let now = moment();
            let date_majoration = moment(majorations[i].date);
            if (now.isBefore(date_majoration)) {
                return true;
            }
        }
        return false;
    }

    get_upcoming_majorations() {
        let list_upcoming = [];
        let list_majorations = this.get_majorations();
        for (let i = 0; i < list_majorations.length; i++) {
            let now = moment();
            let date_majoration = moment(list_majorations[i].date);
            if (now.isBefore(date_majoration)) {
                list_upcoming.push(list_majorations[i]);
            }
        }
        return list_upcoming;
    }

    getSimplifiedData() {
        if (!this.selected) return null;
        const infos = {};
        infos.prix = this?.cart?.prix;
        infos.id = this.id;
        infos.nom = this.nom;
        return infos;

    }

}
